import axios from 'utils/axios';
import { all, call, fork, put, retry, takeLatest, select } from 'redux-saga/effects';
import { sagaErrorHandler } from 'shared/helperMethods/sagaErrorHandler';
import { makeSelectAuthToken } from '../../shared/helperMethods/Selectors';
import { getAllBusinessSuccess, getAllBusiness } from './actions';
import { GET_ALL_BUSINESS, ADD_GUEST_USER, DELETE_USER1, CHANGE_USER_STATUS, ADD_RESTRICTED_USER } from './constants';
import { SetNotification } from 'shared/helperMethods/setNotification';

function* addRestrictedUserRequest({ payload }) {
    try {
        const data = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
        const response = yield axios.put(`admin/users/blockUser/${payload.walletAddress}`, data, {
            headers: {
                Authorization: `Bearer ${yield select(makeSelectAuthToken())}`
            }
        });
        yield put(
            getAllBusiness({
                search: payload.search,
                page: payload.page,
                limit: payload.limit,
                type: payload.type
            })
        );
        payload.handleClose();
        yield SetNotification('success', response.data.message);
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}

export function* watchAddRestrictedUser() {
    yield takeLatest(ADD_RESTRICTED_USER, addRestrictedUserRequest);
}

function* getAllBusinessRequest({ payload }) {
    // try {
    //     const axios = require('axios');
    //     let data = '';

    //     let config = {
    //         method: 'get',
    //         maxBodyLength: Infinity,
    //         url: `http://localhost:5000/api/v1/admin/business/search?businessName=${payload.search}`,
    //         headers: {
    //             Authorization:
    //                 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTgsImlhdCI6MTY4NjAzMDIyOX0.v2K0ugg9TLDg-EvPUvkjQ6NRpKTOaHj3B-Xz5YXjWdI'
    //         },
    //         data: data
    //     };

    //     const response = yield axios.request(config);
    //     yield put(getAllBusinessSuccess(response.data.data));
    // } catch (error) {
    //     console.log(error, 'error************');
    // }

    // try {
    //     const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };

    //     const response = yield axios.get(`admin/business/search?businessName=${payload.search}&page=${payload.page}&size=${payload.limit}`, headers);
    //     yield put(getAllBusinessSuccess(response.data.data));
    // } catch (error) {
    //     console.log(error, 'error************');
    // }
}



export function* watchGetAllBusiness() {
    console.log('watchGetAllBusiness**************');
    yield takeLatest(GET_ALL_BUSINESS, getAllBusinessRequest);
}

function* addGuestUserRequest({ payload }) {
    let data = {
        walletAddress: payload.walletAddress
    };
    try {
        const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
        const response = yield axios.post(`admin/users/guest`, data, headers);
        yield put(
            getAllBusiness({
                search: payload.search,
                page: payload.page,
                limit: payload.limit,
                type: payload.type
            })
        );
        payload.handleClose();
        yield SetNotification('success', response.data.message);
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}

export function* watchAddGuestUser() {
    yield takeLatest(ADD_GUEST_USER, addGuestUserRequest);
}

function* deleteUserRequest({ payload }) {
    try {
        const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
        const response = yield axios.delete(`/admin/users/delete/${payload.id}`, headers);
        yield put(
            getAllBusiness({
                search: payload.search,
                page: payload.page,
                limit: payload.limit,
                type: payload.type
            })
        );
        payload.handleClose();
        yield SetNotification('success', response.data.message);
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}

export function* watchDeleteUser() {
    yield takeLatest(DELETE_USER1, deleteUserRequest);
}

function* changeStatusRequest({ payload }) {

}

export function* watchChangeStatus() {
    yield takeLatest(CHANGE_USER_STATUS, changeStatusRequest);
}

export default function* usersSaga() {
    yield all([
        fork(watchGetAllBusiness),
        fork(watchAddGuestUser),
        fork(watchDeleteUser),
        fork(watchChangeStatus),
        fork(watchAddRestrictedUser)
    ]);
}
    // try {
    //     const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
    //     const response = yield axios.put(`/admin/chats/disable/${payload.id}`, {}, headers);
    //     yield put(
    //         getAllBusiness({
    //             search: payload.search,
    //             page: payload.page,
    //             limit: payload.limit,
    //             type: payload.type
    //         })
    //     );
    //     yield SetNotification('success', response.data.message);
    // } catch (error) {
    //     yield sagaErrorHandler(error.response.data.data);
    // }